import { common as c } from '@pendo/aggregations';

export const VALID_KINDS = ['visitors', 'accounts'];

export const VALID_ADOPTION_MATCH_STRATEGIES = ['any', 'all'];

export const PERIOD_MAP = {
    daily: 1,
    weekly: 7,
    monthly: 30,
};

export const UNIT_MAP = {
    daily: 'days',
    weekly: 'weeks',
    monthly: 'months',
};

export type ProductEngagementScoreTimeSeriesRange = {
    start: number | string;
    end: number | string;
    count: number;
};

export function getDaysInPeriodList (periods: number[] = []): number {
    const msInDay = 86400000;
    const start = periods[0];
    const end = periods[periods.length - 1];

    return Math.ceil((end - start) / msInDay);
}

export function getTimeSeriesRangeInterval ({ count }: ProductEngagementScoreTimeSeriesRange): c.TimeSeriesPeriodType {
    if (count < 14) return 'daily';
    if (count < 91) return 'weekly';

    return 'monthly';
}
